import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { ExtensionEvent } from '../models/event';
import { hookSchema } from '../models/hook.schema';
import { hooksListQuerySchema } from './list.schema';

export type HooksListQuery = Partial<{
  id: ID | ID[];
  name: string;
  search: string;
  type: string;
  queue: number;
  active: boolean;
  configAppUrl: string;
  events: ExtensionEvent;
}> &
  PaginationQuery;

export const list = (query: HooksListQuery = {}) => {
  return {
    endpoint: `/hooks`,
    method: 'GET',
    responseSchema: listResponse(hookSchema),
    query: { ...query, includeTotal: true },
    querySchema: hooksListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
